import { combineReducers } from 'redux';
import currentUser from './current-user';
import currentUserSettings from './current-user-settings';
import isAuthenticating from './is-authenticating';
import isAuthenticated from './is-authenticated';

export default combineReducers({
  currentUser,
  currentUserSettings,
  isAuthenticated,
  isAuthenticating,
});



// WEBPACK FOOTER //
// ./app/reducers/auth/index.js